// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m458mrYHTKEvgT {
  display: flex;
  align-items: center;
  column-gap: var(--ds-space-100, 8px);
}
.m458mrYHTKEvgT .qqDblp88QaOOIk {
  display: flex;
  align-items: center;
  column-gap: var(--ds-space-050, 4px);
}
.m458mrYHTKEvgT .vUSxN5l_m39hBH {
  width: 1px;
  height: 24px;
  margin-right: var(--ds-space-100, 8px);
  background-color: var(--ds-border, #091e4224);
}
.m458mrYHTKEvgT .gOHONoP3jRaVMk {
  border-radius: var(--ds-border-radius-200, 8px);
}
.m458mrYHTKEvgT .gOHONoP3jRaVMk span:first-child {
  margin-right: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var container = `m458mrYHTKEvgT`;
export var navigationGroup = `qqDblp88QaOOIk`;
export var verticalDivider = `vUSxN5l_m39hBH`;
export var scheduleAllButton = `gOHONoP3jRaVMk`;
export default ___CSS_LOADER_EXPORT___;
